import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

const SplashPage = () => {
  const navigate = useNavigate();
  const [showButton, setShowButton] = useState(false);
  const [logoLoaded, setLogoLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowButton(true);
    }, 2500);
    return () => clearTimeout(timer);
  }, []);

  const handleEnter = () => {
    navigate("/access");
  };

  return (
    <div 
      className="min-h-screen bg-black flex flex-col items-center justify-center relative overflow-hidden"
      data-testid="splash-page"
    >
      {/* Subtle gold radial gradient */}
      <div 
        className="absolute inset-0 opacity-20"
        style={{
          background: "radial-gradient(circle at center, rgba(122, 98, 0, 0.3) 0%, transparent 60%)"
        }}
      />

      {/* Logo container */}
      <div className="relative z-10 flex flex-col items-center">
        <div 
          className={`transition-opacity duration-1000 ${logoLoaded ? 'opacity-100' : 'opacity-0'}`}
        >
          <img
            src="https://customer-assets.emergentagent.com/job_playb2b/artifacts/9hz9jb8r_Splash.Board2Boston.gif"
            alt="Board2Boston Logo"
            className="w-80 h-auto md:w-96 lg:w-[450px]"
            onLoad={() => setLogoLoaded(true)}
            data-testid="splash-logo"
          />
        </div>

        {/* Tagline */}
        <div 
          className={`mt-8 text-[#A1A1AA] font-ubuntu text-center px-4 transition-all duration-700 whitespace-nowrap ${
            logoLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
          }`}
          style={{ transitionDelay: '0.5s' }}
        >
          <p className="text-2xl md:text-3xl">Welcome to the Future</p>
          <p className="text-lg md:text-xl">of Competitive Gaming and Social Connection.</p>
        </div>

        {/* Enter Button */}
        <div 
          className={`mt-12 transition-all duration-700 ${
            showButton ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
          }`}
        >
          <Button
            onClick={handleEnter}
            className="btn-gold px-12 py-4 text-xl tracking-widest animate-pulse-gold"
            data-testid="enter-button"
          >
            ENTER
          </Button>
        </div>
      </div>

      {/* Footer */}
      <div className="absolute bottom-8 text-center">
        <p className="text-[#52525B] font-ubuntu text-sm">
          © 2026 All Rights Reserved | Board2Boston™ | 713 Consulting and Development
        </p>
      </div>
    </div>
  );
};

export default SplashPage;
